// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Hymb","textarea":"styles_textarea__2RzNe"};